// migration version is also used in InitialLoader
// https://github.com/wix-private/santa-editor/blob/fedf0ccf9cf06eb32cf14c80d370e21ffe30f89f/santa-editor/packages/main/startup/initialLoader/initialLoader.ts
export const MIGRATION_VERSION = '0.0.9';
